import { RoundingStrategy } from "./types";

export const roundNumberByStrategy = (
  value: number,
  roundingStrategy?: RoundingStrategy
): number => {
  let round;

  switch (roundingStrategy) {
    case RoundingStrategy.up:
      round = Math.ceil;
      break;
    case RoundingStrategy.down:
      round = Math.floor;
      break;
    case RoundingStrategy.default:
    default:
      round = Math.round;
  }

  return round(value);
};
